import Image from "next/image";

import styled from "styled-components";

import { APP_SIZE, HEADER_SIZE } from "@styles/variables";
import { grayScale } from "@enkor/design/colors";
import { Typo } from "@enkor/design/components";

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  width: 100%;
  height: 100%;
  /* HACK: Height가 body부터 명확히 정해져 있지 않기 때문에 하위 요소에도 모두 min-height view height를 적용해주어야 컨텐츠 크기가 작을 때도 꽉 채워진 화면을 볼 수 있음.
  + Contents가 들어가는 곳은 Header HEIGHT가 제외된 크기 */
  height: calc(100% - ${HEADER_SIZE.HEIGHT}px);
  min-height: calc(100vh - ${HEADER_SIZE.HEIGHT}px);
  min-height: calc((var(--vh, 1vh) * 100) - ${HEADER_SIZE.HEIGHT}px);
  padding: ${HEADER_SIZE.HEIGHT}px 0 80px;

  background-color: ${grayScale[100]};
`;

export const ImageWrapper = styled.div`
  position: relative;
  overflow: hidden;

  width: 100%;
  max-width: ${APP_SIZE.MAX_WIDTH}px;
  height: auto;
  aspect-ratio: 1/1;
`;

export const MainImage = styled(Image)`
  object-fit: cover;

  width: 100%;
  height: 100%;
`;

export const ContentImageContainer = styled.section``;

export const ContentImageWrapper = styled(ImageWrapper)`
  aspect-ratio: unset;
`;

export const ContentImage = styled(Image)`
  object-fit: cover;

  width: 100%;
  height: 100%;

  display: block;
`;

export const ProjectDescriptionWrapper = styled.div`
  width: 100%;
  padding: 0 16px;
`;

export const ProjectDescription = styled(Typo.Text)`
  white-space: pre-line;
`;
